// Tracks which image filenames are used as section/hero images on the frontend
// (outside of the gallery). Used to warn admins before deleting a gallery image
// that is also displayed elsewhere on the site.

export interface SectionImageUsage {
  filename: string;
  locations: string[];
}

export const SECTION_IMAGE_USAGES: SectionImageUsage[] = [
  { filename: "wooden-island.jpg", locations: ["Homepage hero"] },
  { filename: "history-image.jpg", locations: ["Homepage history section"] },
  { filename: "kitchen-white-island.jpeg", locations: ["Categories strip (Kitchens)", "Trade Partners hero"] },
  { filename: "bathroom-vanity-1.jpg", locations: ["Categories strip (Bathrooms)"] },
  { filename: "laundry-green.jpeg", locations: ["Categories strip (Laundry)"] },
  { filename: "mud-room.jpeg", locations: ["Categories strip (Mud rooms)"] },
  { filename: "tiger-maple-kitchen.jpeg", locations: ["Categories strip (Tiger maple)"] },
  { filename: "kitchen-wine-rack.jpeg", locations: ["Categories strip (Wine rack)"] },
  { filename: "kitchen-skylights.jpeg", locations: ["Berks County page hero"] },
  { filename: "bathroom-vanity-white.jpeg", locations: ["Bathrooms page hero"] },
  { filename: "kitchen-dark-white.jpeg", locations: ["Chester County page hero"] },
  { filename: "green-kitchen.jpeg", locations: ["Kitchens page hero"] },
  { filename: "kitchen-white-marble.jpeg", locations: ["Lancaster County page hero"] },
];

/**
 * Given an image src (which may be a bundled, hashed asset URL like
 * `/assets/kitchen-skylights-DPq7xY9z.jpeg` or a Supabase storage URL),
 * return the list of section-image locations it is used in, if any.
 */
export function findSectionUsages(src: string): string[] {
  const lower = src.toLowerCase();
  const matches: string[] = [];
  for (const usage of SECTION_IMAGE_USAGES) {
    const base = usage.filename.toLowerCase().replace(/\.[^.]+$/, "");
    const ext = usage.filename.toLowerCase().match(/\.[^.]+$/)?.[0] ?? "";
    // Vite hashed assets preserve the original basename, e.g. `kitchen-skylights-HASH.jpeg`
    if (lower.includes(`/${base}-`) && lower.endsWith(ext)) {
      matches.push(...usage.locations);
    } else if (lower.endsWith(`/${usage.filename.toLowerCase()}`)) {
      matches.push(...usage.locations);
    }
  }
  return matches;
}
